import { CMSConnector } from 'umg-cms-js-sdk/src'

export default new CMSConnector()
